import React, { useState, useEffect } from "react";

// internal imports
import RSP_LOGO_RG from "../../assets/RSP_LOGO_RG.png";
import colors from "../../theme";

// external imports
import { useNavigate, useLocation } from "react-router-dom";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ElectricMeterIcon from "@mui/icons-material/ElectricMeter";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import CopyRight2 from "../copyright/CopyRight2";
import PaidIcon from "@mui/icons-material/Paid";
import InfoIcon from "@mui/icons-material/Info";
import TimelapseIcon from "@mui/icons-material/Timelapse";

const categories = [
  {
    id: "Payments",
    children: [
      { id: "Card Details", link: "/card-details", icon: <CreditCardIcon /> },
      {
        id: "Payment History",
        link: "/payment-history",
        icon: <PaidIcon />,
      },
      {
        id: "About Us",
        link: "/about-us",
        icon: <InfoIcon />,
      },
    ],
  },
];

const topMenus = [
  {
    id: "Control Charging",
    link: "/",
    icon: <HomeIcon sx={{ fontSize: "25px !important" }} />,
  },
  {
    id: "Energy",
    link: "/energy",
    icon: <ElectricMeterIcon sx={{ fontSize: "25px !important" }} />,
  },
  {
    id: "Charging Sessions",
    link: "/charging-sessions",
    icon: <AnalyticsIcon sx={{ fontSize: "25px !important" }} />,
  },
  {
    id: "Manage Charge Points",
    link: "/devices",
    icon: <CarRepairIcon sx={{ fontSize: "25px !important" }} />,
  },
  {
    id: "Tariff",
    link: "/tariffs",
    icon: <TimelapseIcon sx={{ fontSize: "25px !important" }} />,
  },
];

const item = {
  py: "2px",
  px: 3,
  color: colors.text,
};

const itemCategory = {
  boxShadow: "0 -1px 0 rgb(255,255,255,0.1) inset",
  py: 1.5,
  px: 3,
};

export default function Navigator(props) {
  const { handleDrawerToggle, ...other } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const handleNavigation = (link) => {
    navigate(link);
    setActiveLink(link);
    if (handleDrawerToggle) {
      handleDrawerToggle();
    }
  };

  return (
    <>
      <Drawer variant="permanent" {...other}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <a href="https://www.readysteadyplug.com/">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  ...item,
                  ...itemCategory,
                  fontSize: 22,
                  color: colors.primary,
                }}
              >
                <img
                  src={RSP_LOGO_RG}
                  alt="RSP Logo"
                  width={188.832}
                  height={30}
                />
              </Box>
            </Box>
          </a>
          {topMenus.map(({ id, link, icon }) => (
            <ListItem
              key={id}
              sx={{
                py: 2,
                px: 3,
                bgcolor:
                  activeLink === link ? colors.hoverBackground : "transparent",
                color: activeLink === link ? colors.primary : colors.white,
              }}
              onClick={() => handleNavigation(link)}
            >
              <ListItemButton sx={{ m: 0, p: 0 }}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{id}</ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
          <Divider sx={{ mt: 2 }} />
          {categories.map(({ id, children }) => (
            <Box key={id} sx={{ bgcolor: colors.background }}>
              <ListItem sx={{ py: 2, px: 3 }}>
                <ListItemText sx={{ color: colors.white }}>{id}</ListItemText>
              </ListItem>
              <List component="div" disablePadding>
                {children.map(({ id: childId, icon, link }) => (
                  <ListItem disablePadding key={childId}>
                    <ListItemButton
                      onClick={() => handleNavigation(link)}
                      sx={{
                        ...item,
                        pl: 4,
                        py: 2,
                        px: 3,
                        bgcolor:
                          activeLink === link
                            ? colors.hoverBackground
                            : "transparent",
                        color:
                          activeLink === link ? colors.primary : colors.white,
                      }}
                    >
                      <ListItemIcon>{icon}</ListItemIcon>
                      <ListItemText>{childId}</ListItemText>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}
          <Box
            component="footer"
            sx={{
              p: 2,
              mt: "auto",
            }}
          >
            <CopyRight2 />
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
